import { NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import { classNames } from "../../helpers/classNames";
import styles from "../../components/sections/admin/site-settings/components/style/Themes.module.css";
import { useSelector } from "react-redux";
import { rgba } from "../../helpers";
import Tooltip from "../elements/Tooltip";

const SidebarMenuItem = ({
  menuLink,
  menuIconColor,
  menuIcon,
  menuLabel,
  isMenuOpen,
  icon,
  blank = false,
}) => {
  const { appliedTheme, selectedElement, status } = useSelector(
    (state) => state?.themeProvider
  );
  const location = useLocation();
  const isExternal = menuLink?.startsWith("http");

  if (isExternal) {
    return (
      <a
        href={menuLink}
        target="_blank"
        rel="noopener noreferrer"
        className={({ isActive }) => {
          const isExactMatch =
            menuLink === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(menuLink);
          return classNames(
            "group text-sm flex items-center gap-1 group hover:text-white hover:bg-primary rounded overflow-hidden p-1 transition-all duration-200",
            isExactMatch ? " !bg-primary" : "",
            isActive ? "text-white" : "text-deep-purple"
          );
        }}
      >
        <>
          <div
            className={() => {
              const isExactMatch =
                menuLink === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(menuLink);
              return classNames(
                "w-12 h-12 flex justify-center items-center text-sm transition-all duration-200 group-hover:!text-white ",
                menuIconColor,
                isExactMatch ? " !text-white" : ""
              );
            }}
          >
            <i className={classNames("fa-fw text-xl", menuIcon)}></i>
          </div>
          <div>{menuLabel}</div>
        </>
      </a>
    );
  }

  return (
    <Tooltip
      className={"w-12 aspect-square"}
      messageClass={"text-base"}
      message={menuLabel}
      position="right"
    >
      <NavLink to={menuLink} {...(blank && { target: "_blank" })}>
        {({ isActive }) => (
          <>
            <div
              className={classNames(
                "w-full h-full rounded-md flex items-center justify-center hover:bg-primary hover:text-white",
                isActive ? "bg-primary text-white" : ""
              )}
            >
              <i className={classNames("fa-fw text-lg md:text-xl", menuIcon)}></i>
            </div>
          </>
        )}
      </NavLink>
    </Tooltip>
  );
};

export default SidebarMenuItem;
